import React, { useCallback, useEffect, useState } from "react";
import Main from "./Main";
import { useSelector } from "react-redux";
import { useNotify } from "../context/NotifyContext";
import useSocketEvent from "../socket/useSocketEvent";
import { fetchDmtLedgers } from "../api/ledgersApi";
import { autoDateFormat } from "../utils/autoDateFormate";
import { formatAmount } from "../utils/formatAmount";
import { exportTable } from "../utils/downloadExcel";
import {
  ListingFilters,
  ListingPagination,
  AppBreadcrumbs,
  useListingState,
} from "../components/listing";

const TeamWallet = () => {
  const { userInfo } = useSelector((state) => state?.auth);
  const { notify } = useNotify();
  const listing = useListingState({ sortBy: "date", sortDir: "desc" });
  const [ledgers, setLedgers] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalLedgers, setTotalLedgers] = useState(0);

  const fetch_ledgers = useCallback(async () => {
    try {
      const result = await fetchDmtLedgers(listing.query);
      if (result?.success) {
        const response = result?.data;
        setLedgers(response?.ledgers || []);
        setTotalPages(response?.pagination?.totalPages || 1);
        setTotalLedgers(response?.pagination?.total || 0);
      } else {
        notify(result?.message || "Server Error", "error");
      }
    } catch (error) {}
  }, [listing.query, notify]);

  useEffect(() => {
    fetch_ledgers();
  }, [fetch_ledgers]);

  useSocketEvent("wallet_changed", fetch_ledgers);

  return (
    <Main showRightPanel={false}>
      <div className="mt-4">
        <AppBreadcrumbs
          items={[
            { label: "Dashboard", to: "/" },
            { label: "Reports" },
            { label: "Team Wallet Load Reports" },
          ]}
        />
        <div className="ds-card mt-4 text-sm">
          <ListingFilters
            onClear={listing.clearFilters}
            startDate={listing.startDate}
            endDate={listing.endDate}
            onStartDate={listing.setStartDate}
            onEndDate={listing.setEndDate}
            search={listing.search}
            onSearch={listing.setSearch}
            searchPlaceholder="Search"
            showApply
            onApply={fetch_ledgers}
            applyLabel="Load Records"
            onExport={() =>
              exportTable(
                "team-wallet-load",
                [
                  { label: "S NO", value: (_r, i) => (listing.page - 1) * listing.limit + i + 1 },
                  { label: "TRANS DATE", value: (r) => autoDateFormat(r?.date) },
                  { label: "AMOUNT", value: (r) => r?.credit || r?.debit || 0 },
                  { label: "REF NUM", value: (r) => r?.refNum || r?.txnId || "" },
                  { label: "DESCRIPTION", value: (r) => r?.narration || "" },
                  { label: "AGENT", value: () => userInfo?.name || "" },
                  { label: "DEBIT", key: "debit" },
                  { label: "CREDIT", key: "credit" },
                  { label: "BALANCE", key: "closingBalance" },
                ],
                ledgers,
                notify
              )
            }
          />
          <div className="ds-table-wrap ds-scroll">
            <table className="ds-table ds-table-listing min-w-[900px]">
              <thead>
                <tr>
                  <th>S NO</th>
                  <th>TRANS DATE</th>
                  <th>AMOUNT</th>
                  <th>REF NUM</th>
                  <th>DESCRIPTION</th>
                  <th>AGENT NAME</th>
                  <th>DEBIT</th>
                  <th>CREDIT</th>
                  <th>BALANCE</th>
                </tr>
              </thead>
              <tbody>
                {ledgers.length === 0 ? (
                  <tr>
                    <td colSpan={9} className="text-center text-[var(--text-muted)]">
                      NO DATA AVAILABLE IN TABLE
                    </td>
                  </tr>
                ) : (
                  ledgers.map((row, index) => (
                    <tr key={row?._id || index}>
                      <td>{(listing.page - 1) * listing.limit + index + 1}</td>
                      <td>{autoDateFormat(row?.date)}</td>
                      <td>{formatAmount(row?.credit || row?.debit)}</td>
                      <td>{row?.refNum || row?.txnId || "--"}</td>
                      <td>{row?.narration || "--"}</td>
                      <td>{userInfo?.name || "--"}</td>
                      <td>{formatAmount(row?.debit)}</td>
                      <td>{formatAmount(row?.credit)}</td>
                      <td>{formatAmount(row?.closingBalance)}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          <ListingPagination
            page={listing.page}
            limit={listing.limit}
            total={totalLedgers}
            totalPages={totalPages}
            onPageChange={listing.setPage}
            onLimit={listing.setLimit}
          />
        </div>
      </div>
    </Main>
  );
};

export default TeamWallet;
